var SuccessIconType = /* @__PURE__ */ ((SuccessIconType2) => {
  SuccessIconType2[SuccessIconType2["success"] = 0] = "success";
  SuccessIconType2[SuccessIconType2["successSolid"] = 1] = "successSolid";
  SuccessIconType2[SuccessIconType2["warning"] = 2] = "warning";
  SuccessIconType2[SuccessIconType2["warningSolid"] = 3] = "warningSolid";
  SuccessIconType2[SuccessIconType2["error"] = 4] = "error";
  SuccessIconType2[SuccessIconType2["errorSolid"] = 5] = "errorSolid";
  SuccessIconType2[SuccessIconType2["blocking"] = 6] = "blocking";
  SuccessIconType2[SuccessIconType2["blockingSolid"] = 7] = "blockingSolid";
  SuccessIconType2[SuccessIconType2["alertSolid"] = 8] = "alertSolid";
  SuccessIconType2[SuccessIconType2["alert"] = 9] = "alert";
  return SuccessIconType2;
})(SuccessIconType || {});
var Icons = /* @__PURE__ */ ((Icons2) => {
  Icons2["Add"] = "Add";
  Icons2["AddFriend"] = "AddFriend";
  Icons2["Archive"] = "Archive";
  Icons2["Back"] = "Back";
  Icons2["VerticalBarChart"] = "BarChartVerticalFill";
  Icons2["Close"] = "ChromeClose";
  Icons2["Clock"] = "Clock";
  Icons2["Contrast"] = "Contrast";
  Icons2["Dataflows"] = "Dataflows";
  Icons2["Delete"] = "Delete";
  Icons2["Download"] = "Download";
  Icons2["Edit"] = "Edit";
  Icons2["EditMirrored"] = "EditMirrored";
  Icons2["Filter"] = "Filter";
  Icons2["Info"] = "Info";
  Icons2["Mail"] = "Mail";
  Icons2["OpenFolder"] = "FabricOpenFolderHorizontal";
  Icons2["OpenInNewWindow"] = "OpenInNewWindow";
  Icons2["RedEye"] = "RedEye";
  Icons2["Refresh"] = "Refresh";
  Icons2["Restart"] = "SyncStatus";
  Icons2["Search"] = "Search";
  Icons2["Settings"] = "Settings";
  Icons2["Start"] = "MSNVideos";
  Icons2["Stop"] = "CircleStop";
  Icons2["Pause"] = "CirclePause";
  Icons2["DirectoryUpload"] = "BulkUpload";
  Icons2["Upload"] = "Upload";
  Icons2["PeopleAdd"] = "PeopleAdd";
  Icons2["CloudDownload"] = "CloudDownload";
  Icons2["CloudUpload"] = "CloudUpload";
  Icons2["MapLayers"] = "MapLayers";
  Icons2["Play"] = "Play";
  Icons2["PageEdit"] = "PageEdit";
  Icons2["PageList"] = "PageList";
  Icons2["PageListSolid"] = "PageListSolid";
  Icons2["Save"] = "Save";
  Icons2["InboxCheck"] = "InboxCheck";
  Icons2["Label"] = "Label";
  Icons2["EditPhoto"] = "EditPhoto";
  Icons2["TriangleRight"] = "TriangleRight12";
  Icons2["TriangleSolidRight"] = "TriangleSolidRight12";
  Icons2["LightningBolt"] = "LightningBolt";
  Icons2["GlobalNavButton"] = "GlobalNavButton";
  Icons2["QuestionMark"] = "StatusCircleQuestionMark";
  Icons2["EraseTool"] = "EraseTool";
  Icons2["GridViewMedium"] = "GridViewMedium";
  Icons2["StepSharedAdd"] = "StepSharedAdd";
  Icons2["Code"] = "Code";
  Icons2["Lightbulb"] = "Lightbulb";
  Icons2["Star"] = "FavoriteStar";
  Icons2["StarFilled"] = "FavoriteStarFill";
  Icons2["Undo"] = "Undo";
  Icons2["ZoomIn"] = "ZoomIn";
  Icons2["Clone"] = "DuplicateRow";
  Icons2["LinkedDatabase"] = "LinkedDatabase";
  Icons2["Warning"] = "Warning";
  Icons2["SkypeCircleCheck"] = "SkypeCircleCheck";
  Icons2["LockSolid"] = "LockSolid";
  Icons2["Financial"] = "Financial";
  Icons2["ViewListTree"] = "ViewListTree";
  Icons2["PageListFilter"] = "PageListFilter";
  Icons2["Help"] = "Help";
  Icons2["Emoji2"] = "Emoji2";
  Icons2["Import"] = "Import";
  Icons2["TaskList"] = "BulletedList2";
  Icons2["NavigateExternalInline"] = "NavigateExternalInline";
  Icons2["CompletedSolid"] = "CompletedSolid";
  Icons2["AlertSolid"] = "AlertSolid";
  Icons2["ErrorOutline"] = "Error";
  Icons2["InfoSolid"] = "InfoSolid";
  Icons2["UnknownSolid"] = "UnknownSolid";
  Icons2["TableComputed"] = "TableComputed";
  Icons2["Devices3"] = "Devices3";
  Icons2["PublishContent"] = "PublishContent";
  Icons2["FullScreen"] = "FullScreen";
  Icons2["ReadingMode"] = "ReadingMode";
  Icons2["TextDocument"] = "TextDocument";
  Icons2["ConnectContacts"] = "ConnectContacts";
  Icons2["ChevronDoubleLeft"] = "DoubleChevronLeft12";
  Icons2["ChevronDown"] = "ChevronDownMed";
  Icons2["ChevronUp"] = "ChevronUpMed";
  Icons2["ChevronRight"] = "ChevronRight";
  Icons2["InlineFailed"] = "StatusErrorFull";
  Icons2["InlineRefresh"] = "SyncStatusSolid";
  Icons2["InlineStart"] = "MSNVideosSolid";
  Icons2["InlineStop"] = "CircleStopSolid";
  Icons2["CollapseContent"] = "CollapseContent";
  Icons2["ExploreContent"] = "ExploreContent";
  Icons2["NewFile"] = "NewFolder";
  Icons2["CreateFile"] = "PageAdd";
  Icons2["NewFolder"] = "FabricNewFolder";
  Icons2["FillFolder"] = "FabricFolderFill";
  Icons2["CommandPrompt"] = "CommandPrompt";
  Icons2["CollapseMenu"] = "CollapseMenu";
  Icons2["DottedProgressRing"] = "ProgressRingDots";
  Icons2["FastForward"] = "FastForward";
  Icons2["Detach"] = "PlugDisconnected";
  Icons2["Attach"] = "PlugConnected";
  Icons2["CircleRing"] = "CircleRing";
  Icons2["Checked"] = "CheckMark";
  Icons2["FilledCircle"] = "CircleFill";
  Icons2["Error"] = "StatusCircleErrorX";
  Icons2["ChartEdit"] = "BarChart4";
  Icons2["TableEdit"] = "TableGroup";
  Icons2["ArchiveExperiment"] = "Favicon";
  Icons2["LineChart"] = "LineChart";
  Icons2["ArrowRight"] = "ChevronRight";
  Icons2["ArrowLeft"] = "ChevronLeft";
  Icons2["Home"] = "Home";
  Icons2["ArrowUp"] = "Up";
  Icons2["ArrowDown"] = "Down";
  Icons2["Table"] = "Table";
  Icons2["Disable"] = "StatusCircleBlock";
  Icons2["Completed"] = "Completed";
  Icons2["ErrorBadge"] = "ErrorBadge";
  Icons2["TriggerAuto"] = "TriggerAuto";
  Icons2["DietPlanNotebook"] = "DietPlanNotebook";
  Icons2["ThisPC"] = "ThisPC";
  Icons2["ConnectVirtualMachine"] = "ConnectVirtualMachine";
  Icons2["ExploreData"] = "ExploreData";
  Icons2["OfflineStorage"] = "OfflineStorage";
  Icons2["Org"] = "Org";
  Icons2["Forward"] = "Forward";
  Icons2["Cancel"] = "Cancel";
  Icons2["DataManagementSettings"] = "DataManagementSettings";
  Icons2["TestBeaker"] = "TestBeaker";
  Icons2["ScatterChart"] = "ScatterChart";
  Icons2["Deploy"] = "Deploy";
  Icons2["Unknown"] = "Unknown";
  Icons2["AzureAPIManagement"] = "AzureAPIManagement";
  Icons2["CubeShape"] = "CubeShape";
  Icons2["Copy"] = "Copy";
  Icons2["Glimmer"] = "Glimmer";
  Icons2["PageHeaderEdit"] = "PageHeaderEdit";
  Icons2["ServerEnvironment"] = "ServerEnviroment";
  Icons2["Ringer"] = "Ringer";
  Icons2["ViewList"] = "ViewList";
  Icons2["OpenPane"] = "OpenPane";
  Icons2["OpenPaneMirrored"] = "OpenPaneMirrored";
  Icons2["PenWorkspace"] = "PenWorkspace";
  Icons2["WebComponents"] = "WebComponents";
  return Icons2;
})(Icons || {});
export {
  Icons,
  SuccessIconType
};
//# sourceMappingURL=Icon.types.js.map
